import React from "react";

import { IconProps } from "./models";

function BankBuildingIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 64 64" {...props}>
      <path d="m3 57h58v4h-58z" fill="#7d8d9c" />
      <path d="m5 53h54v4h-54z" fill="#aabece" />
      <path d="m21 33h6v16h-6z" fill="#cfdfe8" />
      <path d="m3 25h58v4h-58z" fill="#aabece" />
      <g fill="#7d8d9c">
        <path d="m59 25h-54l27-22z" />
        <path d="m19 29h10v4h-10z" />
        <path d="m19 49h10v4h-10z" />
      </g>
      <path d="m7 33h6v16h-6z" fill="#cfdfe8" />
      <path d="m5 29h10v4h-10z" fill="#7d8d9c" />
      <path d="m5 49h10v4h-10z" fill="#7d8d9c" />
      <path d="m51 33h6v16h-6z" fill="#cfdfe8" />
      <path d="m49 29h10v4h-10z" fill="#7d8d9c" />
      <path d="m49 49h10v4h-10z" fill="#7d8d9c" />
      <path d="m37 33h6v16h-6z" fill="#cfdfe8" />
      <path d="m35 29h10v4h-10z" fill="#7d8d9c" />
      <path d="m35 49h10v4h-10z" fill="#7d8d9c" />
      <path
        d="m37 12v-2h-4v-2h-2v2h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h3v2h-4v2h4v2h2v-2h3a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-3v-2zm-2 4v2h-2v-2zm-4-2h-2v-2h2z"
        fill="#fcf05a"
      />
      <path
        d="m22 22h-6a1 1 0 0 1 -.625-1.781l5-4 1.25 1.562-2.774 2.219h3.149z"
        fill="#394d5c"
      />
      <path
        d="m47 22h-6v-2h3.149l-2.774-2.219 1.25-1.562 5 4a1 1 0 0 1 -.625 1.781z"
        fill="#394d5c"
      />
    </svg>
  );
}

export default BankBuildingIcon;
